import { createAsyncAction, createAction } from "typesafe-actions";
import { Comment, FetchedComments } from "./types";
import { Filter } from "../components/highlighting/duck/types";

export const toggleShowAnswers = createAction("TOOLBAR/SHOW_ANSWERS_TOGGLE")();

export const toggleDictionary = createAction("TOOLBAR/DICTIONARY_TOGGLE")();

export const showDictionaryTooltip = createAction(
  "TOOLBAR/DICTIONARY_TOOLTIP_SHOW",
)<{ left: number; top: number }>();

export const hideDictionaryTooltip = createAction(
  "TOOLBAR/DICTIONARY_TOOLTIP_HIDE",
)();

export const setDictionaryWord = createAction(
  "TOOLBAR/DICTIONARY_WORD_SET",
)<string>();

export const handleClick = createAction("TOOLBAR/DICTIONARY_CLICK_HANDLE")<{
  left: number;
  top: number;
}>();

export const handleMouseDown = createAction(
  "TOOLBAR/DICTIONARY_MOUSEDOWN_HANDLE",
)();

export const editWholeSectionComment = createAction(
  "TOOLBAR/WHOLE_SECTION_COMMENT_EDIT",
)();

export const setComments = createAction(
  "TOOLBAR/COMMENTS_SET",
)<FetchedComments>();

export const fetchComments = createAsyncAction(
  "TOOLBAR/COMMENTS_LIST/REQUEST",
  "TOOLBAR/COMMENTS_LIST/SUCCESS",
  "TOOLBAR/COMMENTS_LIST/FAILURE",
)<Filter, never, never>();

export const createComment = createAsyncAction(
  "TOOLBAR/COMMENT_CREATE/REQUEST",
  "TOOLBAR/COMMENT_CREATE/SUCCESS",
  "TOOLBAR/COMMENT_CREATE/FAILURE",
)<Comment, never, never>();

export const updateComment = createAsyncAction(
  "TOOLBAR/COMMENT_UPDATE/REQUEST",
  "TOOLBAR/COMMENT_UPDATE/SUCCESS",
  "TOOLBAR/COMMENT_UPDATE/FAILURE",
)<Comment, never, never>();

export const removeComment = createAsyncAction(
  "TOOLBAR/COMMENT_REMOVE/REQUEST",
  "TOOLBAR/COMMENT_REMOVE/SUCCESS",
  "TOOLBAR/COMMENT_REMOVE/FAILURE",
)<string | undefined, never, never>();

export const setShowCommentsForPrint = createAction(
  "TOOLBAR/SHOW_COMMENTS_FOR_PRINT_SET",
)<boolean>();

export const setSpeechEnabled = createAction(
  "TOOLBAR/SPEECH_ENABLED_SET",
)<boolean>();

export const setScenarioDescription = createAction(
  "TOOLBAR/SCENARIO_DESCRIPTION_SET",
)<string | null>();

export const setAvailableCalculators = createAction(
  "TOOLBAR/AVAILABLE_CALCULATORS_SET",
)<{
  fourFunctionCalculator: boolean;
  scientificCalculator: boolean;
  graphingCalculator: boolean;
} | null>();

export const setPrintEnabled = createAction(
  "TOOLBAR/PRINT_ENABLED_SET",
)<boolean>();
